import { createApp } from 'vue'

import LoadStyles from '../src/mixins/LoadStyles/LoadStyles'
import Menu from '../src/mixins/Menu/Menu'

import mobilemenu from '../src/components/MobileMenu/MobileMenu.vue'
import mobilemenublocker from '../src/components/MobileMenuBlocker/MobileMenuBlocker.vue'

const BASE_ID_SELECTOR = '#vue-mobile-menu'
const BASE_SELECTOR = '.mobile-menu'
const LAST_SEARCHES_SELECTOR = '.mobile-last-searches'

export function initMobileMenu() {
  const mobileMenu = {
    mixins: [Menu],
    // Root components must be imported in lowercase
    components: {
      mobilemenu,
      mobilemenublocker,
    },
    data() {
      return {
        baseSelector: BASE_SELECTOR,
        lastSearchesSelector: LAST_SEARCHES_SELECTOR,
        initializedBookingsForm: false,
      }
    },
    mounted() {
      setTimeout(() => {
        const loader = document.querySelectorAll(`${BASE_ID_SELECTOR} .js-loading`)
        this.initTemplates()
        loader.forEach(loader => loader.remove())
      }, 500)
    },
  }

  const app = createApp(mobileMenu)

  /**
   * TODO: Use Composables instead of Mixins
   * https://vuejs.org/api/options-composition.html#mixins
   * https://vuejs.org/guide/reusability/composables.html
   */
  app.mixin(LoadStyles)
  app.mount(BASE_ID_SELECTOR)
}
